import localize from '../../common/localize';

export default function ApplicationLogoHorizontal({ height, width }) {
  return (
    <img
      width={width}
      height={height}
      alt={localize.logo_alt}
      src={`${process.env.PUBLIC_URL}/img/app_logo_512.png`}
    />
  );
}
